import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00710-upload-form" }
const _hoisted_2 = { class: "row q-gutter-x-xs items-center" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "cmd00710-file-table" }
const _hoisted_5 = { class: "full-width row q-gutter-sm" }
const _hoisted_6 = { class: "q-pt-xs" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "cmd00710-file-table" }
const _hoisted_9 = { class: "row items-center" }
const _hoisted_10 = { class: "q-gutter-sm flex" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "row q-gutter-sm" }
const _hoisted_13 = { class: "row items-center justify-end" }
const _hoisted_14 = { class: "row items-center justify-end" }
const _hoisted_15 = { class: "full-width row q-gutter-sm" }
const _hoisted_16 = { class: "q-pt-xs" }
const _hoisted_17 = { class: "add-btn-area flex items-center filter-select" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "cmd00710-log-table" }
const _hoisted_20 = { class: "full-width row q-gutter-sm" }
const _hoisted_21 = { class: "q-pt-xs" }
const _hoisted_22 = ["href"]

import { ref } from 'vue';
import Loading from 'quasar/src/plugins/Loading.js';;
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import * as FileStatus from '../../common/code/FileStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import commaFormat from '../../common/utils/numberUtils';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import { isFilesExist } from '../../common/utils/fileUtils';

// アップロードSDFile一覧
interface UploadSdfFileList {
  file_name: string;
  file_size: string;
  update_date: string;
}

// SDFileインポート
interface ImportSdfFileList {
  catalog_id: number;
  sup_sdfile_name: string;
  past_file_name: string;
  supplier_name: string;
  sup_category: string;
  memo: string;
}

// インポートログ
interface ImportLogList {
  catalog_id: number;
  sup_sdfile_name: string;
  status: string;
  exec_date_str: string;
  import_start_time: string;
  import_end_time: string;
  import_num: string;
  err_num: string;
  err_sdfile_name: string;
}

// カラム表示機能
interface VisibleColumn {
  name: string;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00710',
  setup(__props) {

const router = useRouter();

// 表示カラム
const visibleColumns = ref<Array<string>>([]);
// カラム表示設定の選択肢
const visibleColumnOptions = ref<Array<VisibleColumn>>([]);
// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);

// Dialogタイトル
const dialogTitle = ref('');
// Dialog表示レベル
const dialogLevel = ref('');
// Dialog本文
const dialogText = ref(['']);
// 確認Dialogフラグ
const isConfFlg = ref(false);

// アップロードDialog表示フラグ
const isUploadDisplayFlg = ref(false);
// アップロード削除Dialog表示フラグ
const isUploadDeleteDisplayFlg = ref(false);
// インポートDialog表示フラグ
const isImportDisplayFlg = ref(false);
// インポート削除Dialog表示フラグ
const isDeleteImportDisplayFlg = ref(false);

// カタログID
const catalogId = ref(0);
// SDFファイル名
const sdfFileName = ref('');
// アップロードファイル
const uploadFiles = ref<File[]>([]);
// 処理スケジュールタイプ(0:処理日時指定 1:即時実行)
const scheduleType = ref('1');
// スケジュール日付
const scheduleDate = ref('');
// スケジュール時間
const scheduleTime = ref('');
// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

// アップロードSDFile一覧カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fileColumns: Array<any> = [
  {
    name: 'editDelete',
    field: (row: UploadSdfFileList) => row.file_name,
  },
  {
    name: ' file_name',
    label: 'SDFile名',
    align: 'left',
    field: (row: UploadSdfFileList) => row.file_name,
    sortable: true,
  },
  {
    name: 'file_size',
    label: 'ファイルサイズ',
    align: 'left',
    field: (row: UploadSdfFileList) => row.file_size,
    classes: 'text-right',
    sortable: true,
  },
  {
    name: 'update_date',
    label: '更新日時',
    align: 'left',
    field: (row: UploadSdfFileList) => row.update_date,
    style: 'width: 160px',
    sortable: true,
  },
];

// SDFileインポートカラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const importColumns: Array<any> = [
  {
    name: 'import',
    label: '',
    align: 'center',
    field: (row: ImportSdfFileList) => row.catalog_id,
    required: true,
  },
  {
    name: 'sup_sdfile_name',
    label: '登録SDFile名',
    align: 'left',
    field: (row: ImportSdfFileList) => row.sup_sdfile_name,
    sortable: true,
  },
  {
    name: 'past_file_name',
    label: '過去SDFile名',
    align: 'left',
    field: (row: ImportSdfFileList) => row.past_file_name,
    sortable: true,
  },
  {
    name: 'supplier_name',
    label: 'サプライヤ名',
    align: 'left',
    field: (row: ImportSdfFileList) => row.supplier_name,
    sortable: true,
  },
  {
    name: 'category_name',
    label: 'カテゴリー',
    align: 'left',
    field: (row: ImportSdfFileList) => row.sup_category,
    sortable: true,
  },
  {
    name: 'memo',
    label: '備考',
    align: 'left',
    field: (row: ImportSdfFileList) => row.memo,
    sortable: true,
  },
];

// インポートログカラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logColumns: Array<any> = [
  {
    name: 'sup_sdfile_name',
    label: 'SDFile名',
    align: 'left',
    field: (row: ImportLogList) => row.sup_sdfile_name,
    sortable: true,
  },
  {
    name: 'status',
    label: 'ステータス',
    align: 'left',
    field: (row: ImportLogList) => row.status,
    sortable: true,
  },
  {
    name: 'exec_date_str',
    label: '取込開始予定日時',
    align: 'left',
    field: (row: ImportLogList) => row.exec_date_str,
    sortable: true,
  },
  {
    name: 'import_start_time',
    label: '取込開始日時',
    align: 'left',
    field: (row: ImportLogList) => row.import_start_time,
    sortable: true,
  },
  {
    name: 'import_end_time',
    label: '取込完了日時',
    align: 'left',
    field: (row: ImportLogList) => row.import_end_time,
    sortable: true,
  },
  {
    name: 'import_num',
    label: '取込品目数',
    align: 'left',
    field: (row: ImportLogList) => row.import_num,
    sortable: true,
  },
  {
    name: 'err_num',
    label: 'エラー品目数',
    align: 'left',
    field: (row: ImportLogList) => row.err_num,
    sortable: true,
  },
  {
    name: 'err_sdfile_name',
    label: 'エラーSDFile',
    align: 'left',
    field: (row: ImportLogList) => row.err_sdfile_name,
    sortable: true,
  },
];

// アップロードSDFile一覧表示データ
const fileData = ref([
  {
    file_name: '',
    file_size: '',
    update_date: '',
  },
]);

// SDFileインポート表示データ
const importData = ref([
  {
    sup_sdfile_name: '',
    past_file_name: '',
    supplier_name: '',
    sup_category: '',
    memo: '',
  },
]);

// インポートログデータ
const logData = ref([
  {
    sup_sdfile_name: '',
    status: '',
    exec_date_str: '',
    import_start_time: '',
    import_end_time: '',
    import_num: '',
    err_num: '',
    err_sdfile_name: '',
  },
]);

/**
 * アップロード確認ダイアログ表示
 */
const displayUploadDialog = () => {
  dialogTitle.value = 'アップロード確認';
  dialogLevel.value = 'information';
  dialogText.value = ['選択したファイルをアップロードします。', 'よろしいですか？'];
  isConfFlg.value = false;
  isUploadDisplayFlg.value = true;
};

/**
 * アップロード完了ダイアログ
 */
const completeUploadDialog = () => {
  dialogTitle.value = 'アップロード完了';
  dialogLevel.value = 'information';
  dialogText.value = ['ファイルのアップロードが完了しました。'];
  isConfFlg.value = true;
  isUploadDisplayFlg.value = true;
};

/**
 * アップロード削除確認ダイアログ表示
 * @param {string} fileName ファイル名
 */
const displayDeleteUploadDialog = (fileName: string) => {
  sdfFileName.value = fileName;
  dialogTitle.value = '削除確認';
  dialogLevel.value = 'information';
  dialogText.value = [`${fileName}を削除します。`, 'よろしいですか？'];
  isConfFlg.value = false;
  isUploadDeleteDisplayFlg.value = true;
};

/**
 * インポート確認ダイアログ表示
 * @param {number} selCatalogId カタログID
 * @param {string} fileName ファイル名
 */
const displayImportDialog = (selCatalogId: number, fileName: string) => {
  // エラー初期化
  errMessage.value = '';
  isMessageChip.value = false;
  catalogId.value = selCatalogId;
  dialogTitle.value = 'スケジュール登録確認';
  dialogLevel.value = 'information';
  dialogText.value = [`${fileName}の取り込みスケジュールを登録します。`, 'よろしいですか？'];
  isConfFlg.value = false;
  isImportDisplayFlg.value = true;
};

/**
 * インポート完了ダイアログ
 */
const completeImportDialog = () => {
  dialogTitle.value = 'スケジュール登録完了';
  dialogLevel.value = 'information';
  dialogText.value = ['スケジュールの登録が完了しました。'];
  isConfFlg.value = true;
  isImportDisplayFlg.value = true;
};

/**
 * インポート削除確認ダイアログ表示
 * @param {number} selCatalogId 選択した行のカタログID
 * @param {string} fileName ファイル名
 */
const displayDeleteImportDialog = (selCatalogId: number, fileName: string) => {
  catalogId.value = selCatalogId;
  sdfFileName.value = fileName;
  dialogTitle.value = '削除確認';
  dialogLevel.value = 'information';
  dialogText.value = [`${fileName}を削除します。`, 'よろしいですか？'];
  isConfFlg.value = false;
  isDeleteImportDisplayFlg.value = true;
};

/**
 * 削除完了ダイアログ
 */
const completeDeleteDialog = () => {
  dialogTitle.value = '削除完了';
  dialogLevel.value = 'information';
  dialogText.value = ['削除が完了しました。'];
  isConfFlg.value = true;
};

/**
 * SDFile項目確認画面に遷移
 * @param {string} fileName ファイル名
 */
const editSdfFormat = (fileName: string) => {
  router.push({ name: 'sdfileSetFormat', params: { fileName } });
};

/**
 * 完了ステータスのSDFにエラーが存在するか判定
 * @param status  ファイルステータス
 * @param endDate 取込完了日時
 * @param errNum  エラー品目数
 * @returns エラーが存在する場合：true 存在しない場合：false
 */
const isSdfCompErrExist = (status: string, endDate: string, errNum: number) => {
  // Statusが完了かつ完了日時が入っていて、エラー品目数が1以上の場合
  if (status === FileStatus.default.COMPLETED && endDate && errNum > 0) {
    return true;
  }
  return false;
};

/**
 * SDFのエラーが存在するか判定
 * @param status  ファイルステータス
 * @param endDate 取込完了日時
 * @param errNum  エラー品目数
 * @returns エラーが存在する場合：true 存在しない場合：false
 */
const isSdfErrExist = (status: string, endDate: string) => {
  if (
    // エラー系Statusかつ完了日時が入っている場合
    (status === FileStatus.default.SDF_IMPORT_ERROR ||
      status === FileStatus.default.SYSTEM_ERROR ||
      status === FileStatus.default.REG_CHECK_ERROR) &&
    endDate
  ) {
    return true;
  }
  return false;
};

/**
 * 初期表示データ取得
 */
const getInitData = () => {
  // Loading Start
  Loading.show();

  axios
    .post('/cmd007101/init')
    .then((res) => {
      const { common, currentDate, currentTime, sdfTempList, sdfImportList, logList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          scheduleDate.value = currentDate;
          scheduleTime.value = currentTime;
          fileData.value = sdfTempList;
          importData.value = sdfImportList;
          logData.value = logList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

/**
 * ファイルアップロード
 */
const uploadFile = () => {
  isUploadDisplayFlg.value = false;
  // エラー初期化
  errMessage.value = '';
  isMessageChip.value = false;

  // Loading Start
  Loading.show();

  const formData = new FormData();
  Object.entries(uploadFiles.value).forEach(([, value]) => {
    formData.append('fileList', value);
  });

  axios
    .post('/cmd007101/sdf-upload', formData)
    .then((res) => {
      const { common, sdfTempList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          fileData.value = sdfTempList;
          uploadFiles.value = [];
          completeUploadDialog();
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * ファイルアップロードチェック
 */
const checkUploadFile = async () => {
  isFilesExist(uploadFiles.value).then((value) => {
    if (value) {
      uploadFile();
    } else {
      dialogTitle.value = 'ファイル読み込みエラー';
      dialogLevel.value = 'error';
      if (uploadFiles.value !== undefined && uploadFiles.value[0].size === 0) {
        dialogText.value = [
          '選択したファイルは内容が設定されていません。',
          'ファイルを再度選択してください。',
        ];
      } else {
        dialogText.value = [
          '更新または削除されたファイルがあるため、アップロードできませんでした。',
          'ファイルを再度選択してください。',
        ];
      }
      isConfFlg.value = true;
      isUploadDisplayFlg.value = true;
    }
  });
};

/**
 * アップロードファイル削除
 */
const deleteUploadFile = () => {
  isUploadDeleteDisplayFlg.value = false;
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('file_name', sdfFileName.value);

  axios
    .post('/cmd007101/delete-upload-file', formData)
    .then((res) => {
      const { common, sdfTempList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          fileData.value = sdfTempList;
          completeDeleteDialog();
          isUploadDisplayFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // ファイルが存在しない場合
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              fileData.value = sdfTempList;
              dialogTitle.value = 'ファイル削除エラー';
              dialogLevel.value = 'error';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isUploadDisplayFlg.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * SDFインポート
 */
const importSdf = () => {
  isImportDisplayFlg.value = false;
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('catalog_id', String(catalogId.value));
  formData.append('schedule_type', scheduleType.value);
  formData.append('schedule_date', scheduleDate.value);
  formData.append('schedule_time', scheduleTime.value);

  axios
    .post('/cmd007101/import-sdf', formData)
    .then((res) => {
      const { common, sdfImportList, logList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          importData.value = sdfImportList;
          logData.value = logList;
          completeImportDialog();
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.DATE_FORMAT_ERROR:
              dialogTitle.value = 'エラー';
              dialogLevel.value = 'error';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isImportDisplayFlg.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * SDFインポート削除
 */
const deleteImportSdf = () => {
  isDeleteImportDisplayFlg.value = false;
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('catalog_id', String(catalogId.value));

  axios
    .post('/cmd007101/delete-import-sdf', formData)
    .then((res) => {
      const { common, sdfTempList, sdfImportList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          fileData.value = sdfTempList;
          importData.value = sdfImportList;
          completeDeleteDialog();
          isDeleteImportDisplayFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * ログ再読み込み
 */
const reloadLog = () => {
  // Loading Start
  Loading.show();

  axios
    .post('/cmd007101/reload-log')
    .then((res) => {
      const { common, logList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          logData.value = logList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 初期表示処理
 */
getInitData();
// カラム表示設定
for (let i = 0; i < importColumns.length; i += 1) {
  visibleColumns.value.push(importColumns[i].name);
  // インポート開始ボタンのカラムは除外
  if (importColumns[i].name !== 'import') {
    visibleColumnOptions.value.push({
      name: importColumns[i].name,
      label: importColumns[i].label,
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[17] || (_cache[17] = [
        _createTextVNode("SDFile登録")
      ])),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[19] || (_cache[19] = _createElementVNode("label", {
        class: "text-weight-bold",
        style: {"font-size":"1.1rem"}
      }, "ファイルアップロード", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_file, {
            modelValue: uploadFiles.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uploadFiles).value = $event)),
            outlined: "",
            multiple: "",
            append: "",
            dense: "",
            clearable: "",
            "use-chips": "",
            accept: ".sdf",
            onClear: _cache[1] || (_cache[1] = ($event: any) => (uploadFiles.value = []))
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "attach_file" })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_q_btn, {
            color: "primary",
            label: "アップロード",
            icon: "mdi-upload",
            disable: uploadFiles.value.length ? false : true,
            class: _normalizeClass(uploadFiles.value.length ? '' : 'cmd00710-disabled-btn'),
            style: {"height":"40px"},
            onClick: displayUploadDialog
          }, null, 8, ["disable", "class"]),
          (uploadFiles.value.length ? false : true)
            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                key: 0,
                anchor: "top middle",
                self: "bottom middle",
                offset: [15, 15]
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createElementVNode("strong", null, "アップロードするファイルを選択してください", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[20] || (_cache[20] = _createElementVNode("label", {
        class: "text-weight-bold",
        style: {"font-size":"1.1rem"}
      }, "アップロードSDFile一覧", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist uploadfile-list ' +
          (fileData.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: fileData.value,
          columns: fileColumns,
          "row-key": "index",
          flat: "",
          dense: "",
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "rows-per-page": "20",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_6, _toDisplayString(message), 1)
            ])
          ]),
          "header-cell-editDelete": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area delete-btn-exists" })
          ]),
          "body-cell-editDelete": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  class: "table-btn-area delete-btn-exists"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_q_btn, {
                        icon: "mdi-pencil",
                        label: "編集",
                        color: "primary",
                        onClick: ($event: any) => (editSdfFormat(cell.row.file_name))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_q_btn, {
                        icon: "mdi-close",
                        label: "削除",
                        class: "deletebtn",
                        color: "primary",
                        outline: "",
                        style: {"color":"var(--q-delete)"},
                        onClick: ($event: any) => (displayDeleteUploadDialog(cell.row.file_name))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          "body-cell": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  props: cell
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.value), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rows", "hide-no-data", "pagination-label"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[22] || (_cache[22] = _createElementVNode("label", {
        class: "text-weight-bold",
        style: {"font-size":"1.1rem"}
      }, "SDFileインポート", -1)),
      _createElementVNode("div", _hoisted_9, [
        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "q-mr-lg" }, "インポート処理日時：", -1)),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_q_radio, {
            modelValue: scheduleType.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((scheduleType).value = $event)),
            val: "1",
            label: "即時実行"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_q_radio, {
              modelValue: scheduleType.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((scheduleType).value = $event)),
              val: "0",
              label: "処理日時指定",
              class: "q-mr-md"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_q_input, {
                modelValue: scheduleDate.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((scheduleDate).value = $event)),
                outlined: "",
                dense: "",
                disable: scheduleType.value === '1' ? true : false,
                class: "date q-pb-none",
                readonly: "",
                style: {"background":"var(--q-white)","width":"140px"}
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "event",
                    class: "cursor-pointer"
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_q_popup_proxy, {
                    cover: "",
                    "transition-show": "scale",
                    "transition-hide": "scale"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_date, {
                        modelValue: scheduleDate.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((scheduleDate).value = $event)),
                        minimal: "",
                        "no-unset": "",
                        mask: "YYYY/MM/DD"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _withDirectives(_createVNode(_component_q_btn, {
                              label: "OK",
                              color: "primary",
                              flat: ""
                            }, null, 512), [
                              [_directive_close_popup]
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disable"]),
              _createVNode(_component_q_input, {
                modelValue: scheduleTime.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((scheduleTime).value = $event)),
                outlined: "",
                dense: "",
                disable: scheduleType.value === '1' ? true : false,
                class: "date q-pb-none",
                readonly: "",
                style: {"background":"var(--q-white)","width":"126px"}
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "access_time",
                    class: "cursor-pointer"
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_q_popup_proxy, {
                    cover: "",
                    "transition-show": "scale",
                    "transition-hide": "scale"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_time, {
                        modelValue: scheduleTime.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((scheduleTime).value = $event)),
                        mask: "HH:mm",
                        format24h: false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _withDirectives(_createVNode(_component_q_btn, {
                              label: "OK",
                              color: "primary",
                              flat: ""
                            }, null, 512), [
                              [_directive_close_popup]
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disable"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist table-top-button ' +
          (importData.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: importData.value,
          columns: importColumns,
          "visible-columns": visibleColumns.value,
          "row-key": "index",
          flat: "",
          dense: "",
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "rows-per-page": "20",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_16, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_q_select, {
                modelValue: visibleColumns.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((visibleColumns).value = $event)),
                multiple: "",
                outlined: "",
                dense: "",
                "options-dense": "",
                "display-value": "カラム表示設定",
                "emit-value": "",
                "map-options": "",
                options: visibleColumnOptions.value,
                "option-value": "name",
                color: "primary",
                class: "column-disp"
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          "header-cell-import": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area delete-btn-exists importbtn" })
          ]),
          "body-cell-import": _withCtx((cell) => [
            _createVNode(_component_q_td, {
              key: "import",
              class: "table-btn-area delete-btn-exists importbtn",
              style: {"text-align":"center"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_q_btn, {
                    color: "primary",
                    label: "インポート開始",
                    icon: "mdi-update",
                    style: {"width":"160px"},
                    onClick: ($event: any) => (displayImportDialog(cell.row.catalog_id, cell.row.sup_sdfile_name))
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_q_btn, {
                    icon: "mdi-close",
                    label: "削除",
                    class: "deletebtn",
                    outline: "",
                    color: "primary",
                    style: {"color":"var(--q-delete)"},
                    onClick: ($event: any) => (displayDeleteImportDialog(cell.row.catalog_id, cell.row.sup_sdfile_name))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          "body-cell": _withCtx((cell) => [
            _createVNode(_component_q_td, { props: cell }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cell.value), 1)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["rows", "visible-columns", "hide-no-data", "pagination-label"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _cache[23] || (_cache[23] = _createElementVNode("label", {
        class: "text-weight-bold",
        style: {"font-size":"1.1rem"}
      }, "インポートログ", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area nofixed-column import-log ' +
          (logData.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          rows: logData.value,
          columns: logColumns,
          "row-key": "index",
          flat: "",
          dense: "",
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_21, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createVNode(_component_q_btn, {
              color: "primary",
              outline: "",
              label: "更新",
              icon: "mdi-autorenew",
              class: "import-reloadbtn",
              onClick: reloadLog
            })
          ]),
          body: _withCtx((cell) => [
            _createVNode(_component_q_tr, { style: {"height":"50px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_td, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.row.sup_sdfile_name), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_td, {
                  style: _normalizeStyle(
                  isSdfErrExist(cell.row.status, cell.row.import_end_time) ? 'color: red' : ''
                )
                }, {
                  default: _withCtx(() => [
                    (
                    isSdfCompErrExist(cell.row.status, cell.row.import_end_time, cell.row.err_num)
                  )
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 0,
                          size: "20px",
                          name: "mdi-alert",
                          style: {"color":"var(--q-informationPublish)"}
                        }))
                      : (isSdfErrExist(cell.row.status, cell.row.import_end_time))
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 1,
                            size: "20px",
                            name: "mdi-close-circle"
                          }))
                        : (cell.row.status === FileStatus.default.SCHEDULED)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 2,
                              size: "20px",
                              name: "mdi-calendar-check"
                            }))
                          : (cell.row.status === FileStatus.default.COMPLETED)
                            ? (_openBlock(), _createBlock(_component_q_icon, {
                                key: 3,
                                size: "20px",
                                name: "mdi-check-circle",
                                style: {"color":"green"}
                              }))
                            : (_openBlock(), _createBlock(_component_q_icon, {
                                key: 4,
                                size: "20px",
                                name: "mdi-progress-check"
                              })),
                    _createTextVNode(" " + _toDisplayString(isSdfCompErrExist(cell.row.status, cell.row.import_end_time, cell.row.err_num)
                    ? '完了(エラー有り)'
                    : FileStatus.getName(cell.row.status)), 1)
                  ]),
                  _: 2
                }, 1032, ["style"]),
                _createVNode(_component_q_td, { style: {"width":"160px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.row.exec_date_str), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_td, { style: {"width":"160px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.row.import_start_time), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_td, { style: {"width":"160px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.row.import_end_time), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_td, { class: "text-right" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.row.import_num ? _unref(commaFormat)(cell.row.import_num) : cell.row.import_num), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_td, { class: "text-right" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.row.err_num ? _unref(commaFormat)(cell.row.err_num) : cell.row.err_num), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_td, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      style: {"text-decoration":"none","color":"red"},
                      href: `/cmd007101/download-err-sdf?catalogId=${cell.row.catalog_id}`
                    }, [
                      (cell.row.err_sdfile_name)
                        ? (_openBlock(), _createBlock(_component_q_chip, {
                            key: 0,
                            clickable: "",
                            outline: "",
                            square: "",
                            color: "red",
                            "text-color": "black",
                            icon: "mdi-download"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(cell.row.err_sdfile_name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_22)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["rows", "hide-no-data", "pagination-label"])
      ], 2)
    ]),
    _createVNode(AlertDialog, {
      display: isUploadDisplayFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[9] || (_cache[9] = ($event: any) => (isUploadDisplayFlg.value = false)),
      onConfirm: checkUploadFile,
      onClose: _cache[10] || (_cache[10] = ($event: any) => (isUploadDisplayFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isUploadDeleteDisplayFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[11] || (_cache[11] = ($event: any) => (isUploadDeleteDisplayFlg.value = false)),
      onConfirm: deleteUploadFile,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (isUploadDeleteDisplayFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isImportDisplayFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[13] || (_cache[13] = ($event: any) => (isImportDisplayFlg.value = false)),
      onConfirm: importSdf,
      onClose: _cache[14] || (_cache[14] = ($event: any) => (isImportDisplayFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isDeleteImportDisplayFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[15] || (_cache[15] = ($event: any) => (isDeleteImportDisplayFlg.value = false)),
      onConfirm: deleteImportSdf,
      onClose: _cache[16] || (_cache[16] = ($event: any) => (isDeleteImportDisplayFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"])
  ]))
}
}

})